export const SelectionModes = {
  ALL: 'all',
  SOME: 'some',
} as const;
